var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"long-page-sheet"},[_c('the-summary'),_c('the-showroom'),_c('the-features'),_c('the-accessories'),_c('the-equipments')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }